import { UnsafePageDescription, UnsafePageTitle, UnsafePageWrapper } from '@style/pages/page.style';

import { Button } from '@atom/button/button';
import { ButtonTypeEnum } from '@atom/button/button.enum';
import { Form } from '@component/forms/common.style';
import { RouteEnum } from '@enum/route.enum';
import { ResetPasswordForm } from '@form/reset-password/reset-password.form';

import { useForgotPassword } from './forgot-password.hook';
import { FormWrapper } from './forgot-password.style';

export const ForgotPasswordPage = () => {
  const { form, isLoading, error, onReset, isSent } = useForgotPassword();

  return (
    <UnsafePageWrapper>
      <UnsafePageTitle>{isSent ? 'Reset password email has been sent' : 'Forgot password'}</UnsafePageTitle>
      <UnsafePageDescription>
        {isSent ? 'Check your email and follow instructions' : 'Send me a password reset link. Add you email below.'}
      </UnsafePageDescription>
      <FormWrapper>
        {isSent && (
          <Button href={RouteEnum.Login.path} type={ButtonTypeEnum.Primary} block>
            BACK TO LOGIN PAGE
          </Button>
        )}
        {!isSent && (
          <Form.Provider onFormFinish={onReset}>
            <ResetPasswordForm error={error} form={form} isLoading={isLoading} />
          </Form.Provider>
        )}
      </FormWrapper>
    </UnsafePageWrapper>
  );
};
